import React, { Component } from "react";
import "./portfolio.css";
import Loader from ".././../../../components/loader/loader";
import firebase from "firebase";

export default class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [],
      loading: true,
    };
  }

  componentDidMount() {
    firebase
      .firestore()
      .collection("projects")
      .limit(3)
      .get()
      .then((snap) => {
        var projects = [];
        snap.forEach((doc) => projects.push(doc.data()));
        this.setState({
          projects: projects,
          loading: false,
        });
      });
  }

  render() {
    return (
      <div>
        {this.state.loading ? (
          <Loader />
        ) : (
          <div className="portfolio">
            <h1>PORTFOLIO</h1>
            <div className="portfolio-main">
              <h2>HAVE A LOOK AT OUR PROJECTS</h2>
              <div className="portfolio-content">
                {this.state.projects.map((project) => (
                  <a href={project.url} target="_blank" className="card">
                    <img src={project.image} alt="" />
                    <div className="cardDetail">
                      <h3>{project.title}</h3>
                      <h4>{project.description}</h4>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
